export default __webpack_public_path__ + "static/media/Cadence and Haydn.721aaf4c.jpg";